import { PictureAsPdf } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { colors } from "@rubi/ui";
import { useTranslation } from "react-i18next";

import LazyLoadVideo from "@/common/LazyLoadVideo";

const PdfThumbnail = ({
  onClick,
  style,
}: {
  onClick?: () => void;
  style?: React.CSSProperties;
}) => {
  const { t } = useTranslation("common");

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        cursor: onClick ? "pointer" : "default",
        backgroundColor: colors.action.hover,
        borderRadius: "4px",
        ...style,
      }}
    >
      <PictureAsPdf sx={{ fontSize: 64, color: colors.error.main }} />
      <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
        {t("mediaDisplay.pdfDocument")}
      </Typography>
    </Box>
  );
};

const MediaDisplay = ({
  mediaType,
  src,
  onClick,
  onLoad,
  style,
  customVideoErrorMessage,
  handleVideoErrorClick,
}: {
  mediaType: "video" | "image" | "pdf";
  src: string;
  onClick?: () => void;
  onLoad?: any;
  style?: React.CSSProperties;
  customVideoErrorMessage?: string;
  handleVideoErrorClick?: () => void;
}) => {
  const { t } = useTranslation("common");

  if (mediaType === "pdf") {
    return <PdfThumbnail onClick={onClick} style={style} />;
  }
  if (mediaType === "video") {
    return (
      <LazyLoadVideo
        src={src}
        controls={true}
        onClick={onClick}
        style={{
          cursor: "pointer",
          ...style,
        }}
        handleLoad={onLoad}
        errorMessage={customVideoErrorMessage}
        handleVideoErrorClick={handleVideoErrorClick}
      />
    );
  }
  return (
    <img
      src={src}
      alt={t("mediaDisplay.loadedContentAlt")}
      onLoad={onLoad}
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    />
  );
};

export default MediaDisplay;
